import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import BlogDetails from './BlogDetails';
import SinglePostSidebar from './SinglePostSidebar';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/Footer';
import Newsletter from '../../components/Common/Newsletter';
import ScrollToTop from '../../components/Common/ScrollTop';
import OffWrap from '../../components/Layout/Header/OffWrap';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import SearchModal from '../../components/Layout/Header/SearchModal';

// Image
import favIcon from '../../assets/img/fav-orange.png';
import Logo from '../../assets/img/logo/cat_logo.png';
import footerLogo from '../../assets/img/logo/cat_logo.png';

import postImage from '../../assets/img/blog/inner/1.jpg';
import post1Image from '../../assets/img/blog/inner/b5.jpeg'

// Breadcrumbs Background Image
import bannerbg from '../../assets/img/breadcrumbs/5.jpg';

const SinglePostRightSidebar = (props) => {

    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu='blog'
                secondParentMenu='blogSingle'
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar='enable'
                TopBarClass="topbar-area home8-topbar"
                emailAddress='perfectschool777@gmail.com'
            />

            <SiteBreadcrumb
                pageTitle="Освіта дорослих"
                pageName="Освіта дорослих"
                breadcrumbsImg={bannerbg}
            />

            {/* Blog Details Start */}
            <div className="rs-inner-blog orange-style pt-100 pb-100 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 order-last">
                            <div className="widget-area">
                                <SinglePostSidebar />
                            </div>
                        </div>
                        <div className="col-lg-8 pr-50 md-pr-14">
                          <div className="blog-deatails">
                            <div className="bs-img">
                                <img
                                    src={post1Image}
                                    alt="Post Image"
                                />
                            </div>
                            <div className="blog-full">
                                <div className="blog-desc">
                                    <p>
                                      Більшість людей у школі вивчали іноземні мови, і переважно це англійська. Доросла людина звертається до нас за допомогою у вивченні англійської мови з різних причин, але одна мета - заговорити. Наше завдання як викладачів – показати, розповісти та навчити. Навчання дорослої людини істотно відрізняється від принципів навчання дітей. Однією з причин є те, що дитина приходить до нас з величезним кредитом довіри, у дорослих ж цю довіру потрібно заслужити, тому що у них за плечима є певний досвід як спілкування, так і вивчення. Великим плюсом є те, що у дорослих більше мотивації, і змушувати їх не потрібно, вони робитимуть все самі. В першу чергу викладач у жодному разі не повинен показувати свою перевагу і не повинен жодним чином конкурувати з дорослим студентом. Краще стати другом та показати свою готовність допомогти будь-якими способами. Але й здобути авторитет важливо. Студент повинен хотіти приходити/вчити/пізнавати більше не тому, що "треба", а тому, що ми викликали в нього цей інтерес. Друге, що обов'язково повинен зробити вчитель - переконати студентів у своїй компетентності, оскільки в більшості випадків дорослі люди спочатку ставляться скептично до незнайомих людей, тим більше до тих, які їх чогось навчатимуть. Причиною такої поведінки є усталені стереотипи і принципи людини, що сформувала, з певним багажем знань і досвіду. Наступним етапом побудови довірчих відносин є гумор, звісно, в міру. Це не означає, що протягом усього заняття потрібно розповідати анекдоти, ні. По-перше, посміхаючись, людина розслаблюється і розуміє, що вона в безпеці, по-друге, з гарним настроєм і справа йде краще. Таким чином можна відволіктися від суворих буднів і відпочити від повсякденної метушні. З чого ще слід починати, то це з попередньої оцінки знань та визначення цілей. Тут важливо переконати студента в тому, що скільки б не було у нього знань, ми їх примножимо і соромитися не варто, дати зрозуміти, що він потім і прийшов, щоб покращити ситуацію і незабаром з гордістю показати найкращий результат. Побудова довірчих і доброзичливих відносин із дорослими ґрунтується не лише на вищевикладених принципах, які скоріше йдуть паралельно, ніж по порядку, я вважаю їх одними з основних, без яких навчання буде неможливим. PS: перед кожним заняттям пропонувати каву або чай, доливати туди коньяку і дати закусити печивом:). Гарні стосунки гарантовані.
                                    </p>
                                </div>
                            </div>
                        </div>
                            {/* <BlogDetails /> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Blog Details End */}

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop
                scrollClassName="scrollup orange-color"
            />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
}


export default SinglePostRightSidebar;



